<template>
  <div>
    <t-section-header :header="header" :icon="icon">
      <template #input>
        <slot name="input" />
      </template>
    </t-section-header>

    <slot />
  </div>
</template>

<script setup lang="ts">
import TSectionHeader from "@/components/core/TSectionHeader.vue";

interface Props {
  header?: string;
  icon?: string;
}

const { icon, header } = defineProps<Props>();

defineOptions({ name: "TSection" });
</script>
